import { colors } from '@/theme/foundations/colors';
import { shadows } from '@/theme/foundations/shadows';
import { sizes } from '@/theme/foundations/sizes';
import { zIndices } from '@/theme/foundations/z-index';

import { spacing } from './spacing';
import { typography } from './typography';

const foundations = {
  colors,
  ...typography,
  shadows,
  sizes,
  space: spacing,
  zIndices,
};

export default foundations;
